import type { SourceRow } from "./types";

/**
 * Workbook column that holds administrators' working comments. It is moved to
 * the `intervention_comments` table on import (readers can fetch `row_data`),
 * and written back to this column on export. The same name is used by
 * scripts/import-excel-to-supabase.mjs and supabase/migrations/004_working_comments.sql.
 */
export const WORKING_COMMENT_COLUMN = "Data_b#Working comments";

export interface SplitWorkingComments {
  /** The rows without the working-comment column. */
  rows: SourceRow[];
  /**
   * Comment per row ID ("" means no comment), or `null` when the workbook has
   * no such column, in which case existing comments are left alone.
   */
  comments: Map<string, string> | null;
}

/** Separates working comments from imported workbook rows. */
export function splitWorkingComments(rows: SourceRow[]): SplitWorkingComments {
  if (!rows.some((row) => WORKING_COMMENT_COLUMN in row)) return { rows, comments: null };
  const comments = new Map<string, string>();
  const stripped = rows.map((row) => {
    const { [WORKING_COMMENT_COLUMN]: value, ...rest } = row;
    const id = String(row.ID ?? "").trim();
    if (id) comments.set(id, String(value ?? "").trim());
    return rest;
  });
  return { rows: stripped, comments };
}
